export default __webpack_public_path__ + "static/media/oneh2.9929a4df.png";